/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_External_Directories_TitleInputs */

const en_directory_external_directories_title = /** @type {(inputs: Directory_External_Directories_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where to launch next: the curated directory catalog`)
};

const zh_directory_external_directories_title = /** @type {(inputs: Directory_External_Directories_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一步去哪发布：精选目录大全`)
};

/**
* | output |
* | --- |
* | "Where to launch next: the curated directory catalog" |
*
* @param {Directory_External_Directories_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_external_directories_title = /** @type {((inputs?: Directory_External_Directories_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_External_Directories_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_external_directories_title(inputs)
	return zh_directory_external_directories_title(inputs)
});
export { directory_external_directories_title as "directory.external_directories.title" }